// frontend/src/styles/visuallyHidden.js
//
// The one visually-hidden recipe for MUI `sx`: text that screen readers read
// but the screen does not show (and an input that stays focusable and
// clickable through its label).
//
// "1px" / "-1px" are STRINGS on purpose: MUI sx reads a bare `1` for
// width/height as 100%, which makes the "hidden" box as wide as its container
// (a scrollbar in a dialog, a sideways overflow in LTR), and a bare `-1` for
// margin as one theme spacing unit (-8px).

export const VISUALLY_HIDDEN_SX = Object.freeze({
  position: "absolute",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: 0,
  border: 0,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  whiteSpace: "nowrap",
});
